import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const DropZoneEmptyWrapper = styled.div`
  > div:first-child {
    display: flex;
    justify-content: center;
    padding-bottom: 15px;
    > svg {
      width: 75px;
      height: 75px;
    }
  }
  > p:nth-child(2) {
    margin: 16px 0;
  }
  span {
    font-weight: 700;

    &:nth-child(1) {
      margin-right: 5px;
    }
    &:nth-child(2) {
      margin-left: 5px;
    }
  }
`;

export const DropZonePreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  @media ${device.tablet} {
    height: 275px;
    overflow: auto;
  }
`;

export const DropZonePreviewItem = styled.div`
  margin: 10px;
  border: 1px solid #644e02;
  > div:nth-child(1) {
    padding: 10px;
    > img {
      height: 100%;
      width: 200px;
    }
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #644e02;
    padding: 0 10px;
    > span:first-child {
      max-width: 160px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    span:last-child {
      cursor: pointer;
      padding: 10px;
    }
  }
`;
